/* maeda-en® - 2026/06/22 - taste compare feature */

var STORAGE_KEY = 'maeda_en_compare';
var TASTE_AXES = ['Umami', 'Rich', 'Infusion Color', 'Aroma', 'Astringency'];
var TASTE_KEYS = ['umami', 'rich', 'color', 'aroma', 'astringency'];
var MAX_COMPARE = 3;
/* maeda-en® - 2026/06/30 - visibility pass: distinct hues per tea, fill at 15-20% opacity, line/dot at full color */
var COMPARE_COLORS = [
  { fill: 'rgba(92,138,58,0.18)',  line: '#5C8A3A', swatch: '#5C8A3A' },
  { fill: 'rgba(200,151,58,0.18)', line: '#C8973A', swatch: '#C8973A' },
  { fill: 'rgba(168,98,60,0.18)',  line: '#A8623C', swatch: '#A8623C' }
];

var chartInstance = null;

async function fetchProduct(handle) {
  var res = await fetch('/products/' + handle + '?view=taste-compare');
  var text = await res.text();
  if (!res.ok) {
    throw new Error('fetchProduct failed for "' + handle + '": HTTP ' + res.status);
  }
  try {
    return JSON.parse(text);
  } catch (e) {
    throw new Error('fetchProduct got invalid JSON for "' + handle + '": ' + e.message);
  }
}

function getHandles() {
  var params = new URLSearchParams(window.location.search);
  var p = params.get('p');
  if (p) return p.split(',').filter(Boolean).slice(0, MAX_COMPARE);
  try {
    var raw = localStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) || []) : [];
  } catch (e) { return []; }
}

function renderChart(products) {
  var canvas = document.getElementById('maeda-compare-radar');
  if (!canvas) return;
  if (chartInstance) { chartInstance.destroy(); chartInstance = null; }
  chartInstance = new Chart(canvas, {
    type: 'radar',
    data: {
      labels: TASTE_AXES,
      datasets: products.map(function(p, i) {
        return {
          label: p.title,
          data: TASTE_KEYS.map(function(k) { return p.taste[k] || 0; }),
          backgroundColor: COMPARE_COLORS[i].fill,
          borderColor: COMPARE_COLORS[i].line,
          borderWidth: 2,
          pointBackgroundColor: COMPARE_COLORS[i].line,
          pointRadius: 4,
          pointHoverRadius: 6
        };
      })
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        r: {
          min: 0,
          max: 5,
          ticks: {
            stepSize: 1,
            backdropColor: 'transparent',
            color: '#7a7a7a',
            font: { size: 11, family: 'Noto Sans, Helvetica Neue, Arial, sans-serif' }
          },
          grid: { color: '#d4d4d4' },
          angleLines: { color: '#d4d4d4' },
          pointLabels: {
            color: '#111111',
            font: { size: 13, family: 'Noto Sans, Helvetica Neue, Arial, sans-serif', weight: '500' }
          }
        }
      },
      plugins: {
        /* maeda-en® - 2026/07/06 - レイアウト変更で凡例が不要になったため非表示化。display:falseのみ有効にし、元のスタイル設定は復元しやすいようコメントで保持（display未指定だとChart.js側のデフォルトで再表示されてしまうため） */
        legend: {
          display: false
          /*
          position: 'bottom',
          labels: {
            boxWidth: 12,
            padding: 14,
            color: '#111111',
            font: { size: 14, family: 'EB Garamond, Georgia, serif', weight: '500' }
          }
          */
        },
        tooltip: {
          backgroundColor: '#1a1a1a',
          padding: 10,
          titleFont: { family: 'Noto Sans, Helvetica Neue, Arial, sans-serif', weight: '600' },
          bodyFont: { family: 'Noto Sans, Helvetica Neue, Arial, sans-serif' }
        }
      }
    }
  });
}

function renderTable(products) {
  var el = document.getElementById('maeda-compare-table');
  if (!el) return;
  var headerCols = products.map(function(p, i) {
    return '<th><span class="maeda-cp-dot" style="background:' + COMPARE_COLORS[i].swatch + '"></span>' + p.title + '</th>';
  }).join('');
  var rows = TASTE_AXES.map(function(ax, axIdx) {
    var key = TASTE_KEYS[axIdx];
    var cells = products.map(function(p) {
      var val = p.taste[key] || 0;
      var dots = Array.from({ length: 5 }, function(_, i) {
        return '<svg class="maeda-cp-leaf maeda-cp-leaf--' + (i + 1) + (i < val ? ' on' : '') + '" viewBox="0 0 26 17" xmlns="http://www.w3.org/2000/svg"><path d="M 0.5 16.5 A 21.241 21.241 0 0 1 25.5 0.5 A 21.241 21.241 0 0 1 0.5 16.5 Z"/></svg>';
      }).join('');
      return '<td><div class="maeda-cp-cell"><span class="maeda-cp-score">' + val + '</span><span class="maeda-cp-stars">' + dots + '</span></div></td>';
    }).join('');
    return '<tr><td>' + ax + '</td>' + cells + '</tr>';
  }).join('');
  el.innerHTML = '<table class="maeda-compare-table"><thead><tr><th>Axis</th>' + headerCols + '</tr></thead><tbody>' + rows + '</tbody></table>';
}

function renderProducts(products) {
  var el = document.getElementById('maeda-compare-products');
  if (!el) return;
  el.innerHTML = products.map(function(p, i) {
    return '<div class="maeda-cp-card">' +
      '<div class="maeda-cp-card__image"><img src="' + p.image + '" alt="' + p.title + '" loading="lazy"></div>' +
      '<div class="maeda-cp-card__body">' +
        '<h3 class="maeda-cp-card__title"><span class="maeda-cp-dot" style="background:' + COMPARE_COLORS[i].swatch + '"></span>' + p.title + '</h3>' +
        '<div class="maeda-cp-card__price">' + p.price + '</div>' +
        '<div class="maeda-cp-card__actions">' +
          '<a class="maeda-cp-card__btn-primary" href="' + p.url + '">View details</a>' +
          '<button class="maeda-cp-card__btn-secondary" data-remove="' + p.handle + '">Remove</button>' +
        '</div>' +
      '</div>' +
    '</div>';
  }).join('');

  el.querySelectorAll('[data-remove]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var handle = btn.dataset.remove;
      var remaining = getHandles().filter(function(h) { return h !== handle; });

      /* maeda-en® - 2026/07/06 - 比較の最低数(2件)を下回ったら1件だけ裏に残さず、Clear Comparisonと同じ完全リセットにする */
      if (remaining.length < 2) {
        try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
        if (typeof window.maedaClearCompareBar === 'function') window.maedaClearCompareBar();
        window.history.replaceState({}, '', window.location.pathname);
      } else {
        try { localStorage.setItem(STORAGE_KEY, JSON.stringify(remaining)); } catch (e) {}
        if (new URLSearchParams(window.location.search).get('p')) {
          window.history.replaceState({}, '', window.location.pathname + '?p=' + remaining.join(','));
        }
      }
      initComparePage();
    });
  });
}

/* maeda-en® - 2026/07/06 - Clear Comparison等の切り替えをフェードさせる。CSS側のtransition時間(0.2s)と合わせる */
var FADE_MS = 200;

function fadeOut(el) {
  return new Promise(function(resolve) {
    if (!el) return resolve();
    el.classList.add('is-fading');
    setTimeout(resolve, FADE_MS);
  });
}

function fadeIn(el) {
  if (!el) return;
  requestAnimationFrame(function() { el.classList.remove('is-fading'); });
}

/* maeda-en® - 2026/07/06 - assets/maeda-en-taste-compare.jsも同名のグローバルinit()を持ち、後から読み込まれる側が上書きしてしまうため改名 */
async function initComparePage() {
  var contentEl = document.getElementById('maeda-compare-content');
  await fadeOut(contentEl);
  await renderComparePage();
  fadeIn(contentEl);
}

async function renderComparePage() {
  var handles = getHandles();
  var emptyEl = document.getElementById('maeda-compare-empty');
  var chartWrap = document.getElementById('maeda-compare-chart-wrap');
  var tableEl = document.getElementById('maeda-compare-table');
  var productsEl = document.getElementById('maeda-compare-products');

  var subEl = document.getElementById('maeda-compare-sub');

  if (handles.length < 2) {
    if (subEl) subEl.textContent = 'Select at least two teas to compare.';
    if (emptyEl) emptyEl.hidden = false;
    if (chartWrap) chartWrap.hidden = true;
    if (tableEl) tableEl.innerHTML = '';
    if (productsEl) productsEl.innerHTML = '';
    return;
  }

  if (subEl) subEl.textContent = 'Comparing ' + handles.length + ' tea' + (handles.length > 1 ? 's' : '') + ' across five taste axes. Each axis is scored 1–5 (5 = strongest).';
  if (emptyEl) emptyEl.hidden = true;
  if (chartWrap) chartWrap.hidden = false;

  /* maeda-en® - 2026/06/30 - a single failed product fetch used to throw here and silently abort the whole render (including the Clear Comparison button wiring below); now it degrades to a visible message instead */
  try {
    var products = await Promise.all(handles.map(fetchProduct));
    renderChart(products);
    renderTable(products);
    renderProducts(products);
  } catch (e) {
    console.error('Taste compare render failed:', e);
    if (subEl) subEl.textContent = 'Could not load one of the selected teas. Please try again.';
    if (chartWrap) chartWrap.hidden = true;
    if (tableEl) tableEl.innerHTML = '';
    if (productsEl) productsEl.innerHTML = '';
  }
}

function setupClear() {
  var clearBtn = document.getElementById('maeda-compare-page-clear');
  if (!clearBtn) return;
  clearBtn.onclick = function() {
    try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
    /* maeda-en® - 2026/06/30 - also reset the floating compare bar (maeda-en-taste-compare.js), same as its own Clear button */
    if (typeof window.maedaClearCompareBar === 'function') window.maedaClearCompareBar();
    window.history.replaceState({}, '', window.location.pathname);
    initComparePage();
  };
}

function showToast(msg) {
  var toast = document.getElementById('maeda-compare-toast');
  if (!toast) return;
  toast.textContent = msg;
  toast.classList.add('is-visible');
  setTimeout(function() { toast.classList.remove('is-visible'); }, 2000);
}

function setupShare() {
  var shareBtn = document.getElementById('maeda-compare-share');
  if (!shareBtn) return;
  shareBtn.addEventListener('click', function() {
    var handles = getHandles();
    var url = handles.length
      ? window.location.origin + window.location.pathname + '?p=' + handles.join(',')
      : window.location.origin + window.location.pathname;
    navigator.clipboard.writeText(url).then(function() {
      showToast('Copied!');
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() { initComparePage(); setupShare(); setupClear(); });
} else {
  initComparePage();
  setupShare();
  setupClear();
}
